module.exports = __webpack_public_path__ + "img/Desserts To Die For.dd3bffb8.jpg";